import {
  baseScreen,
} from 'hoc';
import React from 'react';
import i18n from 'i18n-js';
import {
  useStores,
} from 'hooks';
import {
  useHistory,
  useParams,
} from 'react-router';
import * as Yup from 'yup';
import GeneralFormFields from 'src/components/GeneralFormView/types';
import GeneralFormView from 'src/components/GeneralFormView';
import {
  FormFieldsBuilder,
} from 'src/components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  LanguagesKey,
} from 'src/translations/types';
import {
  ServiceProviderType,
} from '../serviceProverTypes/types';

const serviceProverTypesForm: React.FC = () => {
  const {
    backend: {
      serviceProviderTypes,
    },
  } = useStores();
  const history = useHistory();
  const {
    id: serviceProviderTypeId,
  } = useParams() as any;
  return (
    <GeneralFormView<any, ServiceProviderType>
      title={i18n.t('SERVICE_PROVIDER_TYPES')}
      identifier="id"
      defaultLang=""
      otherLanguages={[]}
      formData={new FormFieldsBuilder<ServiceProviderType>()
        .addField('englishName', {
          type: GeneralFormFields.INPUT_FIELD,
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          title: i18n.t('ENGLISH_TITLE'),
          fieldOptions: {},
        })
        .addField('arabicName', {
          type: GeneralFormFields.INPUT_FIELD,
          validationSchema: Yup.string().required(i18n.t('REQUIRED_FIELD')),
          title: i18n.t('ARABIC_TITLE'),
          fieldOptions: {},
        })
        .formFields}
      isFetchSuccessful
      update={async (id, data) => {
        try {
          if (serviceProviderTypeId) {
            await serviceProviderTypes.updateServiceProviderType(serviceProviderTypeId, {
              translations: [
                {
                  languageCode: LanguagesKey.AR,
                  title: data.arabicName,
                }, {
                  languageCode: LanguagesKey.EN,
                  title: data.englishName,
                },
              ],
            });
          }
          history.push('/system-setup/system-setup/service-provider-types');
          return Promise.resolve();
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      create={async (data) => {
        try {
          await serviceProviderTypes.create({
            translations: [
              {
                languageCode: LanguagesKey.AR,
                title: data.arabicName,
              }, {
                languageCode: LanguagesKey.EN,
                title: data.englishName,
              },
            ],
          });
          history.push('/system-setup/system-setup/service-provider-types');
          return Promise.resolve(1);
        } catch (error) {
          return Promise.reject(error);
        }
      }}
      get={async () => {
        let res: any = {};
        if (serviceProviderTypeId) {
          res = await serviceProviderTypes.getOne(serviceProviderTypeId);
        }
        return Promise.resolve(new ServiceProviderType(res));
      }}
    />
  );
};

export const ServiceProverTypesForm = baseScreen(serviceProverTypesForm, {
  allowedRoles: ['ADMIN', 'NONE'],
});
